import { Heart, Recycle, ShieldCheck, Gift } from "lucide-react";

const values = [
  {
    icon: Heart,
    title: "Bring back The Spark!",
    description: "Remember when gifts used to mean something? Add a personal 'Spark' note to every gift — a few words about why you chose it. It's the bit that makes people tear up.",
  },
  {
    icon: Recycle,
    title: "Reduce waste",
    description: "Australians chuck over $921 million worth of unwanted gifts every Christmas. That's not a typo. Hintsly helps make sure gifts are actually wanted — so they stay out of landfill.",
  },
  {
    icon: ShieldCheck,
    title: "Avoid gift awkwardness",
    description: "No more fake smiles. No more three identical blenders. Everyone sees what's been claimed, so you can relax knowing your money went somewhere useful.",
  },
  {
    icon: Gift,
    title: "Get what you actually want",
    description: "Your list, your call. Add links, ideas, vibes, cash funds, charity donations — whatever feels right. It's your wishlist, not a department store's.",
  },
];

const ValuePropsGrid = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="container max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          Why Hintsly?
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Because nobody needs another candle they didn't ask for.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div
              key={v.title}
              className="bg-card rounded-2xl p-6 card-elevated border border-border"
            >
              <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mb-4">
                <v.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-bold text-foreground mb-2">{v.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{v.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropsGrid;
